import React, { useCallback, useEffect, useState } from 'react'
import { NewsExploitationModel, NewsMarketingModel, NewsModel } from '../../../types/news/newsModel'
import { newsEnum } from '../../../enums/newsEnum'
import { FormattedMessage, useIntl } from 'react-intl'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { RootState } from '../../reducers'
import { connect, useDispatch } from 'react-redux'
import { formatDateLong } from '../../../utils/formatDate'
import parse from 'html-react-parser'
import Link from '../../../components/link/Link'
import { useHistory, useRouteMatch } from 'react-router'
import links from '../../../enums/linksEnum'
import fetchFactory from '../../../utils/fetchFactory'
import Loader from '../../../components/loader/Loader'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import { useMediaQuery } from 'react-responsive'
import { saveNews } from '../../reducers/news/actions'
import errorCatcher from '../../../utils/errorCatcher'
import { displaySnackbar } from '../../reducers/snackBar/actions'
import { Theme } from '@material-ui/core'
import { AccessibilityModel } from '../../../types/accessibility/accessibilityModel'

const useStyle = makeStyles<Theme, { accessibility: AccessibilityModel }>(
    (theme) => (
        {
            ...styles(theme),
            detailsContainerStyle: {
                position: 'relative',

                '& h1': {
                    margin: 0,
                    color: theme.palette.accessibility.main,
                    wordBreak: 'break-word'
                },
                '& h2': {
                    color: theme.palette.blue.main,
                    wordBreak: 'break-word'
                },
                '& h3': {
                    color: theme.palette.blue.main,
                    wordBreak: 'break-word'
                },
                '& a': {
                    color: theme.palette.green.main,

                    '&::before': {
                        display: 'none'
                    }
                },
                '& p, & li': {
                    color: theme.palette.blue.main,
                    wordBreak: 'break-word'
                },
                '& img': {
                    maxWidth: '100%'
                },
                '& table': {
                    width: '100%',
                    borderCollapse: 'collapse',

                    '& caption': {
                        color: theme.palette.blue.main,
                        textAlign: 'left'
                    },
                    '& thead': {
                        background: 'white',

                        '& th': {
                            color: theme.palette.blue.main,
                            textAlign: 'left'
                        }
                    },
                    '& tbody tr': {
                        background: theme.palette.blue['5'],

                        '& td': {
                            color: theme.palette.blue.main
                        }
                    },
                    '& tbody tr:nth-child(2)': {
                        background: theme.palette.blue['10']
                    }
                },
                '& ul, & ol': {
                    paddingLeft: 15,
                },
                '& ul': {
                    listStyle: props => props.accessibility.isVisualHandicap ? 'url("img/listIconBlue.svg")' : 'url("img/listIcon.svg")'
                },

                '& .encart': {
                    '& > h1': {
                        margin: 0,
                        background: theme.palette.accessibility.main,
                        color: 'white'
                    },
                    '& .encart-content': {
                        background: theme.palette.blue['5'],
                        color: theme.palette.blue.main,

                        '& > a': {
                            textDecoration: 'none',
                            display: 'block',
                            width: 'fit-content',
                            color: 'white',
                            background: theme.palette.blue.main
                        }
                    }
                },

                '& .visuel': {
                    position: 'relative',
                    width: '100%',

                    '& img': {
                        width: '100%'
                    },
                    '& .caption': {
                        wordBreak: 'break-word',
                        padding: '16px 21px',
                        background: theme.palette.blue.main,
                        color: 'white',
                        position: 'absolute',
                        width: '50%',
                        bottom: -20
                    }
                }
            },
            detailsContainerLargeScreenStyle: {
                '& p, & h1, & h2, & h3, & ul, & ol, & .encart': {
                    marginTop: 0,
                    marginBottom: 25
                },
                '& h1': styles(theme).title2,
                '& h2': styles(theme).title3,
                '& h3': styles(theme).text11,
                '& p, & li': styles(theme).text1,

                '& table': {
                    '& caption': {
                        ...styles(theme).title3,
                        marginBottom: 20
                    },
                    '& thead tr': {
                        height: 43,

                        '& th': {
                            ...styles(theme).text8,
                            paddingLeft: 27
                        }
                    },
                    '& tbody tr': {
                        height: 43,

                        '& td': {
                            ...styles(theme).text15,
                            paddingLeft: 27
                        }
                    }
                },

                '& ul, & ol': {
                    '& li': {
                        paddingLeft: 33,
                    }
                },

                '& .encart': {
                    '& > h1': {
                        padding: '25px 50px',
                        ...styles(theme).text11
                    },
                    '& .encart-content': {
                        padding: '34px 50px 48px',
                        ...styles(theme).text1,

                        '& > a': {
                            marginTop: 37,
                            padding: '23px 40px',
                            ...styles(theme).text8
                        }
                    }
                },

                '& .visuel': {
                    marginBottom: 71,
                    '& .caption': {
                        ...styles(theme).text17
                    }
                }
            },
            detailsContainerSmallScreenStyle: {
                '& p, & h1, & h2, & h3, & ul, & ol, & .encart': {
                    marginTop: 0,
                    marginBottom: 25
                },
                '& h1': styles(theme).title3,
                '& h2': styles(theme).title7,
                '& h3': styles(theme).title4,
                '& p, & li': styles(theme).text2,

                '& table': {
                    '& caption': {
                        ...styles(theme).title7,
                        marginBottom: 15
                    },
                    '& thead tr': {
                        height: 35,

                        '& th': {
                            ...styles(theme).text4,
                            paddingLeft: 15
                        }
                    },
                    '& tbody tr': {
                        height: 35,

                        '& td': {
                            ...styles(theme).text3,
                            paddingLeft: 15
                        }
                    }
                },

                '& ul, & ol': {
                    '& li': {
                        paddingLeft: 15
                    }
                },

                '& .encart': {
                    '& > h1': {
                        padding: '15px 25px',
                        ...styles(theme).title4
                    },
                    '& .encart-content': {
                        padding: '15px 25px',
                        ...styles(theme).text2,

                        '& > a': {
                            marginTop: 20,
                            padding: '15px 20px',
                            ...styles(theme).text4
                        }
                    }
                },

                '& .visuel': {
                    marginBottom: 56,
                    '& .caption': {
                        ...styles(theme).text17
                    }
                }
            },
            imageContainerStyle: {
                position: 'absolute',
                background: theme.palette.dynamic['90'],
                zIndex: 1
            },
            imageContainerLargeScreenStyle: {
                left: 95,
                padding: 25,

                '& img': {
                    height: '10vh'
                }
            },
            imageContainerSmallScreenStyle: {
                left: 25,
                padding: 12,

                '& img': {
                    height: '7vh'
                }
            },
            imageStyle: {
                position: 'absolute',
                zIndex: 1
            },
            imageLargeScreenStyle: {
                left: 95,
                height: 285,
                maxWidth: '500px !important'
            },
            imageSmallScreenStyle: {
                left: 25,
                height: 150,
                maxWidth: '180px !important'
            },
            textContainerStyle: {
                '& > .link': {
                    position: 'relative',
                    background: 'white',

                    '& > a': {
                        position: 'absolute'
                    }
                }
            },
            textContainerExploitationLargeScreenStyle: {
                paddingTop: '8vh',

                '& > .link': {
                    padding: '125px 95px 85px',

                    '& > a': {
                        right: 95,
                        top: 45
                    }
                }
            },
            textContainerExploitationSmallScreenStyle: {
                paddingTop: '5vh',

                '& > .link': {
                    padding: '80px 25px 25px',

                    '& > a': {
                        top: 20,
                        right: 25
                    }
                }
            },
            textContainerMarketingLargeScreenStyle: {
                paddingTop: '8vh',

                '& > .link': {
                    padding: '255px 95px 85px',

                    '& > a': {
                        right: 95,
                        top: 45
                    }
                }
            },
            textContainerMarketingSmallScreenStyle: {
                paddingTop: '5vh',

                '& > .link': {
                    padding: '125px 25px 25px',

                    '& > a': {
                        top: 20,
                        right: 25
                    }
                }
            },
            residenceNameStyle: {
                marginTop: 0
            },
            titleStyle: {
                marginTop: '10px !important'
            },
            dateStyle: {
                marginTop: 10
            },
            dateLargeScreenStyle: {
                marginBottom: 50
            },
            dateSmallScreenStyle: {
                marginBottom: 30
            },
            linkStyle: {
                '& a': {
                    marginLeft: 'auto'
                }
            },
            linkLargeScreenStyle: {
                marginTop: 50
            },
            linkSmallScreenStyle: {
                marginTop: 15
            }
        }
    )
)

interface Store {
    news: NewsModel
    saveNews: (news: NewsModel) => void,
    errorCatcher: (error: any, id: string) => void,
    accessibility: AccessibilityModel,
}

interface MatchParamsModel {
    type: string,
    id: string
}

interface AcceptingProps {
    content?: NewsExploitationModel | NewsMarketingModel
}

const initialNews = {
    id: '',
    beginning: '',
    residenceName: '',
    content: '',
    alternative_text: '',
    picture: '',
    type: '',
    title: '',
    end_publication: '',
    hook: '',
    is_published: ''
}
const COMPONENT_NAME = 'details'
const PICTURE = 'picture'

type DetailsProps =
    AcceptingProps
    & Store

const Details: React.FC<DetailsProps> = (
    {
        content,
        news,
        saveNews,
        errorCatcher,
        accessibility
    }
) => {
    const classes = useStyle({ accessibility })
    const history = useHistory()
    const match = useRouteMatch<MatchParamsModel>()
    const intl = useIntl()
    const [selectedNews, setSelectedNews] = useState<NewsExploitationModel | NewsMarketingModel>(content || initialNews)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const errorMessage = intl.formatMessage(
        {
            id: 'news.details.error',
            defaultMessage: 'L\'actualité demandée n\'a pas été trouvée',
            description: 'Error message'
        }
    )

    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const detailContainerClass: ClassValue = classNames(
        classes.detailsContainerStyle,
        isLargeScreen ? classes.detailsContainerLargeScreenStyle : classes.detailsContainerSmallScreenStyle
    )

    const imageClass: ClassValue = classNames(
        classes.imageStyle,
        isLargeScreen ? classes.imageLargeScreenStyle : classes.imageSmallScreenStyle
    )

    const imageContainerClass: ClassValue = classNames(
        classes.imageContainerStyle,
        isLargeScreen ? classes.imageContainerLargeScreenStyle : classes.imageContainerSmallScreenStyle
    )

    const textContainerClass: ClassValue = classNames(
        classes.textContainerStyle,
        {
            [classes.textContainerMarketingLargeScreenStyle]: PICTURE in selectedNews && isLargeScreen,
            [classes.textContainerMarketingSmallScreenStyle]: PICTURE in selectedNews && !isLargeScreen,
            [classes.textContainerExploitationLargeScreenStyle]: !(PICTURE in selectedNews) && isLargeScreen,
            [classes.textContainerExploitationSmallScreenStyle]: !(PICTURE ! in selectedNews) && !isLargeScreen
        }
    )

    const residenceNameClass: ClassValue = classNames(
        classes.residenceNameStyle,
        classes.text6_opacity,
        classes.colorBlue
    )

    const titleClass: ClassValue = classNames(
        classes.title1,
        classes.colorAccessibility,
        classes.titleStyle
    )

    const dateClass: ClassValue = classNames(
        classes.text15,
        classes.colorBlue,
        classes.dateStyle,
        isLargeScreen ? classes.dateLargeScreenStyle : classes.dateSmallScreenStyle
    )

    const linkClass: ClassValue = classNames(
        classes.linkStyle,
        isLargeScreen ? classes.linkLargeScreenStyle : classes.linkSmallScreenStyle
    )

    const goToNews = useCallback(
        () => {
            history.push(links.news)
        }, [history]
    )

    const checkId = useCallback(
        (newsParam: NewsModel, typeInUrl: string, idInUrl: string) => {
            const news = newsParam[typeInUrl as keyof typeof newsEnum].find(
                (news) => news.id === idInUrl
            )

            if (!!news) {
                setSelectedNews(news)
            } else {
                dispatch(
                    displaySnackbar(
                        {
                            id: COMPONENT_NAME,
                            message: errorMessage,
                            open: true,
                            hideIcon: true
                        }
                    )
                )
                goToNews()
            }
        }, [dispatch, errorMessage, goToNews]
    )

    useEffect(
        () => {
            setLoading(true)
            const typeInUrl = match.params.type
            const idInUrl = match.params.id
            window.scrollTo(0, 0)

            if (!content && (news[typeInUrl as keyof typeof newsEnum].length === 0 || (news.locale && news.locale !== intl.locale))) {
                fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getNews?language=${intl.locale}`)
                    .then(
                        (news: any) => {
                            saveNews({ ...news, locale: intl.locale })
                            checkId(news, typeInUrl, idInUrl)
                        }
                    )
                    .catch(
                        (err) => {
                            errorCatcher(err, COMPONENT_NAME)
                        }
                    )
                    .finally(
                        () => {
                            setLoading(false)
                        }
                    )
            } else if (!content) {
                checkId(news, typeInUrl, idInUrl)
            }

            setLoading(false)
        }, [checkId, content, errorCatcher, intl.locale, match.params.id, match.params.type, news, saveNews]
    )

    const back = () => {
        history.goBack()
    }

    return (
        <>
            {
                loading ? (
                    <Loader />
                ) : (
                    <div className={detailContainerClass}>
                        {
                            'picture' in selectedNews ? (
                                <img
                                    src={selectedNews.picture}
                                    alt={selectedNews.alternative_text}
                                    className={imageClass}
                                />
                            ) : (
                                <div className={imageContainerClass}>
                                    <img
                                        src={selectedNews.type}
                                        alt="Exploitation type"
                                    />
                                </div>
                            )
                        }

                        <div className={textContainerClass}>
                            <div className="link">
                                {
                                    !content && (
                                        <Link
                                            color="colorAccessibility"
                                            textStyle="text4"
                                            hasChevron={false}
                                            onClick={back}
                                        >
                                            <KeyboardArrowLeftIcon />

                                            <FormattedMessage
                                                id="app.back"
                                                defaultMessage="Retour"
                                                description="Back button"
                                            />
                                        </Link>
                                    )
                                }

                                {
                                    selectedNews.residenceName && (
                                        <div className={residenceNameClass}>
                                            <span>{selectedNews.residenceName}</span>
                                        </div>
                                    )
                                }

                                <h1 className={titleClass}>{selectedNews.title}</h1>

                                <div className={dateClass}>
									<span>
										{formatDateLong(new Date(selectedNews.beginning), intl.locale)}
									</span>
                                </div>

                                <span>
									{parse(selectedNews.content || '')}
								</span>
                            </div>
                        </div>

                        {
                            !content && (
                                <div className={linkClass}>
                                    <Link
                                        color="colorAccessibility"
                                        textStyle="text8"
                                        onClick={goToNews}

                                    >
                                        <FormattedMessage
                                            id="news.seeAllNews"
                                            defaultMessage="Voir toutes les actualités"
                                            description="See all news link"
                                        />
                                    </Link>
                                </div>
                            )
                        }
                    </div>
                )
            }
        </>
    )
}

const mapStateToProps = (state: RootState) => (
    {
        news: state.news,
        accessibility: state.accessibility
    }
)

const mapDispatchToProps = { saveNews, errorCatcher }

export default connect(mapStateToProps, mapDispatchToProps)(Details)
